export function pesoFilho(valor) {
  var regular = "regular";
  if (valor === "FILHO") {
    return regular;
  }
}
